<template>
  <v-app>
    <div id="app">
      <router-view />
    </div>
  </v-app>
</template>

<script>
export default {
    data: () => ({
    title:"moniqua",
    description: "環境行動を促すためのアプリケーションです。",
  }),
  head: {
    meta: function () {
      return [
        { property: 'og:title', content: this.title},
        { property: 'og:description', content: this.description },
        { name: 'description', content: this.description },
      ]
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #73b7bd 0% 0% no-repeat padding-box;
}
a {
  text-decoration: none;
}
</style>
